import {
  Button,
  Col,
  Input,
  InputRef,
  message,
  Popconfirm,
  Row,
  Table
} from 'antd';
import { ColumnsType } from 'antd/lib/table';
import React, { useState, ReactElement, useRef } from 'react';
import { AccountUser } from '../../../../api/accounts/users';
import { User } from '../../../../interfaces/api/Auth';

interface TeamManagementProps {
  user: User;
  users: AccountUser[];
  invite: (email: string) => Promise<void>;
  remove: (userId: string) => Promise<void>;
}

const TeamManagement = (props: TeamManagementProps): ReactElement => {
  const [inviteeEmail, setInviteeEmail] = useState('');
  const [inviting, setInviting] = useState(false);
  const inviteeEmailInput = useRef<InputRef>(null);
  const columns: ColumnsType<AccountUser> = [
    {
      title: 'Email',
      key: 'email',
      render: (_, user) => <>{user.email ?? user.userId + ' (invited)'}</>
    },
    {
      title: 'Role',
      key: 'role',
      render: () => <>Admin</>
    },
    {
      title: 'Actions',
      key: 'action',
      render: (_, user) => {
        if (user.userId !== props.user.username)
          return (
            <Popconfirm
              title="Remove this user's access to this account and dashboard?"
              onConfirm={() => props.remove(user.userId)}
              okText="Yes"
              cancelText="Cancel"
            >
              <Button type="text" danger>
                remove
              </Button>
            </Popconfirm>
          );
      }
    }
  ];

  const invite = async () => {
    setInviting(true);
    props
      .invite(inviteeEmail)
      .then(() => {
        setInviteeEmail('');
        setInviting(false);
        if (inviteeEmailInput.current?.input?.value) {
          inviteeEmailInput.current.input.value = '';
        }
      })
      .catch((e) => {
        message.error(e);
        setInviting(false);
      });
  };

  const inviteButtonDisabled = () => {
    const validEmailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    return (
      inviteeEmail === '' ||
      props.user.attributes.email === inviteeEmail ||
      !validEmailRegex.test(inviteeEmail)
    );
  };

  return (
    <div style={{ padding: '0 24px' }}>
      <Table
        columns={columns}
        dataSource={props.users.sort((a, b) => {
          return (
            new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
          );
        })}
        pagination={false}
      />
      <Row style={{ padding: '8px 0' }} gutter={8}>
        <Col>
          <Input
            ref={inviteeEmailInput}
            onChange={(event) => {
              setInviteeEmail(event.target.value);
            }}
          />
        </Col>
        <Col>
          <Button
            disabled={inviteButtonDisabled()}
            loading={inviting}
            type="primary"
            onClick={invite}
          >
            Invite
          </Button>
        </Col>
      </Row>
    </div>
  );
};
export default TeamManagement;
